import React, { Component } from "react";
import { connect } from 'react-redux';
import { Button, Form, InputGroup, FormControl } from 'react-bootstrap';

import { createRole } from "../actions/api"
import Table from './table';
const tableSchema = [
  {
    title: 'Role Id',
    // width: 120,
    data: 'id'
  },
  {
    title: 'Role Name',
    // width: 180,
    data: 'name'
  },
  {
    title: 'Permissions',
    // width: 180,
    data: 'permissions'
  },
  {
    title: 'Created at',
    // width: 180,
    data: 'created_at'
  }
];
class Roles extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };

  }
  renderInput() {
    if (!this.state.renderInput) {
      this.setState({ renderInput: true });
    }
  }
  renderTable() {
    if (this.state.renderInput) {
      this.setState({ renderInput: false });
    }
  }
  handleCreateUser() {
    const { name, email, contact_number, password } = this.state;
    this.props.createUser({ name, email, contact_number, password })
    this.resetForm();
  }
  resetForm() {
    this.setState({
      name: "",
      email: "",
      contact_number: "",
      password: ""
    })
  }
  handleInput(context, event) {
    if (context === "name") this.setState({ name: event.target.value })
    else if (context === "email") this.setState({ email: event.target.value })
    else if (context === "password") this.setState({ password: event.target.value })
    else if (context === "contact_number") this.setState({ contact_number: event.target.value })
  }
  shouldComponentUpdate(nextProps, nextState) {
      if (nextProps.roles !== this.state.roles) {
          this.setState({ roles: nextProps.roles });
          return false
      }
      return true
  }

  render() {
    const component = (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <br>
            </br>
            {!this.state.renderInput ?
              <>
                <div className="justify-content-end">
                  <Button onClick={() => this.renderInput()} variant="primary" style={{
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    fontWeight: "600"
                  }} >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13" width="11px" height="11px" fill="#ffffff"><g data-name="Layer 2"><path d="M6.5.5v12m6-6H.5" fill="none" stroke="#ffffff" strokeLinecap="round"></path></g></svg>
                Add new Role
              </Button >
                </div>
                {/* <div className="row"> */}
                {/* <div className="col-sm-12"> */}
                <Table data={this.state.roles} schema={tableSchema} />
                {/* </div> */}
                {/* </div> */}
              </> :

              <div className="row align-items-center">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <Form>
                    <div className="sticky-wrapper">
                      <div className="row">
                        <div className="col-sm-6 header-title" >
                          <h2>Create a role</h2  >
                        </div>

                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-9 col-lg-9 " style={{ padding: '4px' }}>
                        <div className="shadow-lg p-3 mb-5 bg-white rounded">
                          <div className="row">
                            <div className="col-md-6 col-sm-12">
                              <Form.Group controlId="formName">
                                <Form.Label><b>Name</b></Form.Label>
                                <Form.Control type="text" placeholder="Enter Name" value={this.state.name} onChange={(e) => this.handleInput("name", e)} />
                              </Form.Group>
                            </div>
                            <div className="col-md-6 com-sm-12">
                              <Form.Group>
                                <Form.Label><b>Email</b></Form.Label>
                                <InputGroup className="mb-2">
                                  <InputGroup.Prepend>
                                    <InputGroup.Text>@</InputGroup.Text>
                                  </InputGroup.Prepend>
                                  <FormControl id="inlineFormInputGroup" placeholder="Enter email" value={this.state.email} onChange={(e) => this.handleInput("email", e)} />
                                </InputGroup>
                              </Form.Group>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6 col-sm-12 col-lg-6">
                              <Form.Group controlId="formName">
                                <Form.Label><b>Password</b></Form.Label>
                                <Form.Control type="text" placeholder="Enter temporary password" value={this.state.password} onChange={(e) => this.handleInput("password", e)} />
                              </Form.Group>
                            </div>
                            <div className="col-md-6 com-sm-12 col-lg-6">
                              <Form.Group>
                                <Form.Label><b>Contact</b></Form.Label>
                                <InputGroup className="mb-2">
                                  <FormControl id="inlineFormInputGroup" placeholder="Enter contact number" value={this.state.contact_number} onChange={(e) => this.handleInput("contact_number", e)} />
                                </InputGroup>
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3 col-lg-3 col-sm-3" style={{ padding: '4px' }}>
                        <div className="shadow-lg p-3 mb-5 bg-white rounded">
                          <Form.Group controlId="exampleForm.ControlSelect1">
                            <Form.Label><b>Role</b></Form.Label>
                            <Form.Control as="select">
                              {/* {roleOptions} */}
                              <option>1</option>
                              <option>2</option>
                              <option>3</option>
                              <option>
                              <Form.Control as ="select">
                                <option>41</option>
                                <option>42</option>
                                <option>43</option>
                              </Form.Control></option>
                            </Form.Control>
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-sm-6 col-md-6 col-lg-6 justify-content-end">
                        <Form.Group className="">
                          <Button variant="cancel" style={{ paddingLeft: "15px", paddingRight: "15px", fontWeight: 600 }} onClick={() => this.resetForm()}>Reset</Button>
                          <Button variant="success" style={{ minWidth: "150px", paddingLeft: "15px", fontWeight: 600 }} onClick={() => this.handleCreateUser()}>Add</Button>
                          <Button onClick={() => { this.renderTable(); this.resetForm() }} variant="danger" style={{ minWidth: "150px", fontWeight: 600 }} > Cancel</Button>
                        </Form.Group>
                      </div>
                    </div>

                  </Form>
                </div>
              </div >}
          </div>
        </div>

      </div>

    );
    if (this.props.permissons && !this.props.permissons.includes('ADD_USER'))
    // if (true)
      return (<div style={{padding:'10px'}}>You are not authorized to access this page!</div>)
    else return component;
  }
}

// export default Users;
export default connect(({ roles }) => ({ roles }), { createRole })(Roles);
